export default __webpack_public_path__ + "static/media/brands.f79c880a.png";